import moment from "moment";

export const PUBLIC_HOLIDAY_SURCHARGE_RATE = 0.1;

export const PUBLIC_HOLIDAY_SURCHARGE_NOTICE =
  "This date is a public holiday for your selected location. A 10% surcharge applies.";

/** Calendar legend body — prefix with <strong>PH</strong> + space in JSX. */
export const PUBLIC_HOLIDAY_CALENDAR_LEGEND =
  "marks a date that is a public holiday in the state or territory of your selected location. A 10% surcharge applies.";

/** IANA timezone → AU subdivision (must match ccw_backend/helpers/australianPublicHolidaysMerged.js). */
const TIMEZONE_TO_AU_SUBDIVISION = {
  "Australia/Brisbane": "qld",
  "Australia/Sydney": "nsw",
  "Australia/Melbourne": "vic",
  "Australia/Hobart": "tas",
  "Australia/Adelaide": "sa",
  "Australia/Darwin": "nt",
  "Australia/Perth": "wa",
  "Australia/Canberra": "act",
  "Australia/Broken_Hill": "nsw",
  "Australia/Lord_Howe": "nsw",
  "Australia/Currie": "tas",
  "Australia/Eucla": "wa",
};

export function resolveAuSubdivisionFromTimezone(timezone) {
  if (!timezone || typeof timezone !== "string") return null;
  return TIMEZONE_TO_AU_SUBDIVISION[timezone.trim()] || null;
}

/** Query string for GET /booking-flow/public-holidays from a location object. */
export function publicHolidaysQueryForLocation(location) {
  const subdivision = resolveAuSubdivisionFromTimezone(location?.timezone);
  if (!subdivision) return null;
  return `state=${subdivision}`;
}

/** Rounded to cents; 10% of service total after discounts. */
export function computePublicHolidaySurchargeAmount(
  subtotalAfterDiscounts,
  isPublicHoliday,
) {
  const base =
    typeof subtotalAfterDiscounts === "number" ? subtotalAfterDiscounts : 0;
  if (!isPublicHoliday || base <= 0) return 0;
  return (
    Math.round(base * PUBLIC_HOLIDAY_SURCHARGE_RATE * 100) / 100
  );
}

/**
 * Normalizes Step 1 cart `selectedDate` values to YYYY-MM-DD (Australia calendar date).
 */
export function selectedBookingDateToIso(selectedDate) {
  if (!selectedDate) return null;

  const now = moment();
  const todayFormatted = now.format("dddd, MMMM Do YYYY");
  const tomorrowFormatted = now.clone().add(1, "day").format("dddd, MMMM Do YYYY");
  const thirdFormatted = now.clone().add(2, "day").format("dddd, MMMM Do YYYY");

  if (selectedDate === "Today" || selectedDate === todayFormatted) {
    return now.format("YYYY-MM-DD");
  }
  if (selectedDate === "Tomorrow" || selectedDate === tomorrowFormatted) {
    return now.clone().add(1, "day").format("YYYY-MM-DD");
  }
  if (selectedDate === thirdFormatted) {
    return now.clone().add(2, "day").format("YYYY-MM-DD");
  }

  const strict = moment(
    selectedDate,
    ["dddd, MMMM Do YYYY", "YYYY-MM-DD"],
    true,
  );
  if (strict.isValid()) {
    return strict.format("YYYY-MM-DD");
  }

  const loose = moment(selectedDate);
  return loose.isValid() ? loose.format("YYYY-MM-DD") : null;
}
